/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useEffect, useRef, useState } from "react";
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import {
  formatServiceCode,
  formatUid,
  getApiUrl,
  degressToPosition,
  positionToDegress,
} from "../../utils";
import {
  WELL_KNOWN_POSITION,
  USER_GBN,
  TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON,
  TI_SEARCH_ADDRESS_TAB_BUTTON,
  TI_WIDGET_TABLE,
} from "../../Constants";
import WidgetVisibleRadius from "./widgets/WidgetVisibleRadius";
import WidgetSearchByUid from "./widgets/WidgetSearchByUid";
import WidgetServiceCode, {
  OPTIONS as SERVICE_CODE_OPTIONS,
} from "./widgets/WidgetServiceCode";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import Seperator from "./widgets/Seperator";
import WidgetVworldCityTypeForCenter from "./widgets/WidgetVworldCityTypeForCenter";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetTable from "./widgets/WidgetTable";
import EllipsisText from "./widgets/EllipsisText";
import AlignRightText from "./widgets/AlignRightText";
import WidgetCustomerCode, {
  CUSTOMER_OPTIONS as CUSTOMER_CODE_OPTIONS,
} from "./widgets/WidgetCustomerCode";
import AlignCenterText from "./widgets/AlignCenterText";
import { message } from "antd";
import useVworldCityType from "./useVworldCityType";
import { StyledButton, WidgetButton } from "../../styled-components/Button";
import WidgetPlainContainer from "./widgets/WidgetPlainContainer";

const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.남산공원,
  zoom: 16,
};

const ICON_LEGEND = [
  ["out-none", "옥외"],
  ["in-none", "옥내"],
];

const ICON_LEGEND2 = [
  [
    "none",
    "※ 해당 서비스는 기지국 데이터 현행화 과정에 의해 일부 차이가 있을 수 있습니다.",
  ],
];

const style2 = {
  right: "120px",
};

const legendStyle2 = {
  backgroundColor: "rgba(255, 255, 255, 0)",
  boxShadow: "none",
};

const CUSTOMER_NO_DICT = {
  SK: [542604, 2390, 48805, 541309, 521297, 195403],
  KT: [542610, 2151, 33141, 42233, 83943, 89987],
  LG: [39818, 259976],
};


const ICON_MAPPING = {
  // vendorName
  SK: {
    // 옥내
    true: {
      // service_code
      //      '05': ['2g-sk-in', '2G'],
      //      '06': ['2g-sk-in', '2G'],
      15: ["3g-orange-in", "3G"],
      18: ["4g-blue-in", "4G"],
      19: ["4g-blue-in", "4G"],
      43: ["5g-yellow-in", "5G"],
      45: ["5g-yellow-in", "5G"],
    },
    // 옥외
    false: {
      //      '05': ['2g-sk-out', '2G'],
      //      '06': ['2g-sk-out', '2G'],
      15: ["3g-orange-out", "3G"],
      18: ["4g-blue-out", "4G"],
      19: ["4g-blue-out", "4G"],
      43: ["5g-yellow-out", "5G"],
      45: ["5g-yellow-out", "5G"],
    },
  },
  KT: {
    // 옥내
    true: {
      //      '05': ['2g-kt-in', '2G'],
      //      '06': ['2g-kt-in', '2G'],
      15: ["3g-orange-in", "3G"],
      18: ["4g-blue-in", "4G"],
      19: ["4g-blue-in", "4G"],
      43: ["5g-yellow-in", "5G"],
      45: ["5g-yellow-in", "5G"],
    },
    // 옥외
    false: {
      //      '05': ['2g-kt-out', '2G'],
      //      '06': ['2g-kt-out', '2G'],
      15: ["3g-orange-out", "3G"],
      18: ["4g-blue-out", "4G"],
      19: ["4g-blue-out", "4G"],
      43: ["5g-yellow-out", "5G"],
      45: ["5g-yellow-out", "5G"],
    },
  },
  LG: {
    // 옥내
    true: {
      //      '05': ['2g-lg-in', '2G'],
      //      '06': ['2g-lg-in', '2G'],
      15: ["3g-orange-in", "3G"],
      18: ["4g-blue-in", "4G"],
      19: ["4g-blue-in", "4G"],
      43: ["5g-yellow-in", "5G"],
      45: ["5g-yellow-in", "5G"],
    },
    // 옥외
    false: {
      //      '05': ['2g-lg-out', '2G'],
      //      '06': ['2g-lg-out', '2G'],
      15: ["3g-orange-out", "3G"],
      18: ["4g-blue-out", "4G"],
      19: ["4g-blue-out", "4G"],
      43: ["5g-yellow-out", "5G"],
      45: ["5g-yellow-out", "5G"],
    },
  },
};


/*
//이동통신 무선국 찾기 아이콘 변경. MHS
const ICON_MAPPING = {
  // vendorName
  SK: {
    true: { //옥내
      15: ["3g-sk-in", "3G"],
      18: ["4g-sk-in", "4G"],
      19: ["4g-sk-in", "4G"],
      43: ["5g-sk-in", "5G"],
      45: ["5g-sk-in", "5G"],
    },
    false: { //옥외
      15: ["3g-sk-out", "3G"],
      18: ["4g-sk-out", "4G"],
      19: ["4g-sk-out", "4G"],
      43: ["5g-sk-out", "5G"],
      45: ["5g-sk-out", "5G"],
    },
  },
  KT: {
    true: { //옥내
      15: ["3g-kt-in", "3G"],
      18: ["4g-kt-in", "4G"],
      19: ["4g-kt-in", "4G"],
      43: ["5g-kt-in", "5G"],
      45: ["5g-kt-in", "5G"],
    },
    false: { //옥외
      15: ["3g-kt-out", "3G"],
      18: ["4g-kt-out", "4G"],
      19: ["4g-kt-out", "4G"],
      43: ["5g-kt-out", "5G"],
      45: ["5g-kt-out", "5G"],
    },
  },
  LG: {
    true: { //옥내
      15: ["3g-lg-in", "3G"],
      18: ["4g-lg-in", "4G"],
      19: ["4g-lg-in", "4G"],
      43: ["5g-lg-in", "5G"],
      45: ["5g-lg-in", "5G"],
    },
    false: { //옥외
      15: ["3g-lg-out", "3G"],
      18: ["4g-lg-out", "4G"],
      19: ["4g-lg-out", "4G"],
      43: ["5g-lg-out", "5G"],
      45: ["5g-lg-out", "5G"],
    },
  },
};
*/

message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoByZoom = () => {
  message.info({
    content: (
      <span style={{ fontSize: 15 }}>
        {" "}
        해당 zoom에서는 검색이 불가합니다. 확대해 주시기 바랍니다.
      </span>
    ),
  });
};

const MapCellularSearch = () => {
  const [isTableVisible, setTableVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [service_code, setServiceCode] = useState();
  const mapProps = useMapProps({
    INITIAL_VISIBLE_RADIUS: 500,
    INITIAL_VIEW_STATE,
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: (feature) => {
        const { customer_no, service_name, service_code, rds_svc_form_cd } =
          feature;

        // Warning: Cannot update a component from inside the function body of a different component.
        // 라는 경고가 200개씩 콘솔창에 찍히기 때문에, 아래에 useEffect()를 사용해서 setServiceCode(service_code) 했습니다.
        // setServiceCode(service_code);

        const vendorName = Object.entries(CUSTOMER_NO_DICT)
          .filter(([vendorName, customerNoList]) =>
            customerNoList.includes(customer_no)
          )
          .map(([vendorName]) => vendorName)[0];

        try {
          const isIndoor = service_name.indexOf("옥내") > -1;
          return ICON_MAPPING[vendorName][isIndoor][
            String(service_code || rds_svc_form_cd)
          ][0];
        } catch (e) {
          //console.error("not found iconCode for", vendorName, service_name.indexOf("옥내"), rds_svc_form_cd);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;
        if (zoom <= 12) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 11;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 13) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 5;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 14) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 3;
          return Math.min(25.2, iconWidth);
        } else if (zoom === 15) {
          iconWidth -= (iconWidth * (16 - Math.max(7, zoom))) / 4;
          return Math.min(30, iconWidth);
        } else if (zoom >= 16) {
          return 30;
        }
      },
    },
    INITIAL_WIDGET_STATE: {
      service_code_list: SERVICE_CODE_OPTIONS.map(({ value }) => value),
      visible_radius: 500,
      cus_code_list: CUSTOMER_CODE_OPTIONS.map(({ value }) => value),
    },
  });

  const {
    viewState,
    clickedPointIconObjects,
    widgetState,
    setPointsLayerFilterFunc,
    setVisibleRadius,
    setClickedPointIconObjects,
    setNullForMapViewType,
    setSearchByUidForMapViewType,
    setIsClusteringPoint,
    setFilteredPointsResponseList,
  } = mapProps;

  const { latitude, longitude, zoom } = viewState;
  const [vworldCityType, setVworldCityType] = useState();

  // getIconCode 안에서 setServiceCode(service_code) 하게 되면,
  // Warning: Cannot update a component from inside the function body of a different component.
  // 라는 경고가 200개씩 콘솔창에 찍히기 때문에, useEffect()를 사용해서 setServiceCode(service_code) 했습니다.
  useEffect(() => {
    setServiceCode(service_code);
  }, [service_code]);

  useEffect(() => {
    // console.log("zoom level : " + zoom);
    if (zoom < 13) {
      infoByZoom();
    } else if (zoom >= 13) {
      message.destroy();
    }
    // zoom이 15이하일 때는 클러스터링 보기, 초과부터 아이콘 보기
    if (zoom <= 15) {
      setIsClusteringPoint(true);
    } else if (zoom > 15) {
      setIsClusteringPoint(false);
    }
  }, [zoom]);

  useEffect(() => {
    const { service_code_list, visible_radius, cus_code_list } = widgetState;
    setPointsLayerFilterFunc(
      () =>
        ({ service_code, customer_no }) =>
          service_code_list
            .map((row) => row.split(","))
            .flat()
            .includes(service_code) &&
          cus_code_list
            .map((row) => row.split(","))
            .flat()
            .includes(customer_no.toString())
    );
    setVisibleRadius(visible_radius);

    // console.log('search_uid_type:', search_uid_type);
  }, [widgetState]);

  const { setPosition: setPositionForCityType } = useVworldCityType(
    (cityType) => {
      setVworldCityType(cityType);
    }
  );

  useEffect(() => {
    setPositionForCityType({ latitude, longitude });
  }, [clickedPointIconObjects]);

  const onClickedPointInWidgetTable = useCallback(
    (feature) => {
      const { latitude, longitude, lat, lon } = feature;
      const newLatitude = positionToDegress(latitude || lat);
      const newLongitude = positionToDegress(longitude || lon);
      const newFeature = { ...feature, position: [newLongitude, newLatitude] };
      setClickedPointIconObjects([newFeature]);

      setTimeout(() => {
        if (closeButtonRef.current) {
          closeButtonRef.current.focus();
        }
      }, 3000);
    },
    [setClickedPointIconObjects]
  );

  const [tabStatus, setTabStatus] = useState("주소 검색");

  const closeButtonRef = useRef();

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetPlainContainer
          onChange={(tabTitle) => {
            if (tabTitle === "허가번호 검색") {
              setSearchByUidForMapViewType();
              setClickedPointIconObjects([]);
              setVisibleRadius(0);
            } else {
              const { visible_radius } = widgetState;
              setVisibleRadius(visible_radius);
              setClickedPointIconObjects([]);
              setFilteredPointsResponseList([]);
              setNullForMapViewType();
            }
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <StyledButton
              isActive={tabStatus === "주소 검색"}
              style={{ borderRadius: "4px 0px 0px 4px" }}
              onClick={() => setTabStatus("주소 검색")}
              tabIndex={TI_SEARCH_ADDRESS_TAB_BUTTON}
            >
              주소 검색
            </StyledButton>
            <StyledButton
              isActive={tabStatus === "허가번호 검색"}
              style={{ borderRadius: "0px 4px 4px 0px" }}
              onClick={() => setTabStatus("허가번호 검색")}
              tabIndex={TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON}
            >
              허가번호 검색
            </StyledButton>
          </div>

          {tabStatus === "주소 검색" && (
            <>
              <WidgetGeocoding 
                onLocationSelectTriggerTable={() => setTableVisible(true)}
              />
              {USER_GBN && (USER_GBN === "2" || USER_GBN === "3") && (
                <WidgetCustomerCode />
              )}
              <WidgetServiceCode />
              <Seperator />
              <WidgetVisibleRadius />
            </>
          )}

          {tabStatus === "허가번호 검색" && (
            <>
              <WidgetSearchByUid fetchUrl={getApiUrl({ type: "type3" })} />
            </>
          )}
        </WidgetPlainContainer>

        <WidgetTableClicked
          closeButtonRef={closeButtonRef}
          fetchUrl={getApiUrl({ type: "type2" })}
          getTitle={(objects) => `${objects.length}개의 무선국`}
          serviceInfo={true}
          objects={clickedPointIconObjects}
          getRowTitle={({ uid, rds_svc_form_cd }) =>
            `${formatUid(uid)} (${formatServiceCode(rds_svc_form_cd)})`
          }
          getRow={({
            uid,
            cls_name,
            address,
            form_name,
            usage,
            customer_name,
            longitude,
            latitude,
          }) => (
            <table>
              <tbody>
                <tr>
                  <th>허가번호</th>
                  <td>{formatUid(uid)}</td>
                </tr>
                <tr>
                  <th>기지국</th>
                  <td>{cls_name}</td>
                </tr>
                {/*<tr>*/}
                {/*  <th>시설자명</th>*/}
                {/*  <td>{customer_name}</td>*/}
                {/*</tr>*/}
                <tr>
                  <th>설(상)치장소</th>
                  <td>{address}</td>
                </tr>
                <tr>
                  <th>이동통신 서비스</th>
                  <td>{form_name}</td>
                </tr>
                <tr>
                  <th>용도지역정보</th>
                  <td>{vworldCityType}</td>
                </tr>
                <tr>
                  <th>경도</th>
                  <td>{`${degressToPosition(longitude)}(${longitude})`}</td>
                </tr>
                <tr>
                  <th>위도</th>
                  <td>{`${degressToPosition(latitude)}(${latitude})`}</td>
                </tr>
              </tbody>
            </table>
          )}
        />

        <WidgetTable
          visible={isTableVisible}
          setVisible={setTableVisible}
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(objects) => `${objects.length}개의 무선국`}
          isUidSearch={true}
          widgetTabIndex={TI_WIDGET_TABLE}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 75,
              align: "center",
              // sorter: makeTableSorterFn("index"),
              // fixed: "left",
            },
            {
              title: "허가번호",
              dataIndex: "uid",
              key: "uid",
              width: 200,
              // render: (uid, feature) =>
              //   WidgetUidWithShortcut({
              //     feature,
              //     onClick: onClickedPointInWidgetTable,
              //   }),
              // sorter: makeTableSorterFn("uid"),
              // fixed: "left",
            },
            {
              title: "설(상)치장소",
              dataIndex: "rds_trs_adr",
              key: "rds_trs_adr",
              width: 500,
              // render: (rds_trs_adr) => <EllipsisText text={rds_trs_adr} />,
              render: (rds_trs_adr) => (
                // <a href="#" onClick={(e) => e.preventDefault()}>
                //   <EllipsisText text={rds_trs_adr} />
                // </a>
                <WidgetButton>
                  <EllipsisText text={rds_trs_adr} />
                </WidgetButton>
              ),              
              // sorter: makeTableSorterFn("rds_trs_adr"),
            },
            {
              title: "용도",
              dataIndex: "service_name",
              key: "service_name",
              width: 400,
              // sorter: makeTableSorterFn("service_name"),
            },
            {
              title: "장치개수",
              dataIndex: "rds_eqm_snu",
              key: "rds_eqm_snu",
              width: 100,
              render: (text) => AlignCenterText({ text }),
              // sorter: makeTableSorterFn("rds_eqm_snu"),
            },
            // {
            //   title: '인증번호', dataIndex: 'toap_no', key: 'TOAP_NO', width: 240
            //   ,render: toap_no => <EllipsisText text={toap_no} />
            //   ,sorter: makeTableSorterFn('toap_no')
            // },
            {
              title: "경도",
              dataIndex: "lon",
              key: "lon",
              width: 140,
              render: (text) => AlignCenterText({ text }),
            },
            {
              title: "위도",
              dataIndex: "lat",
              key: "lat",
              width: 140,
              render: (text) => AlignCenterText({ text }),
            },
            /*
            {
              title: '서비스코드', dataIndex: 'service_code', key: ['frq_hz','service_code'], width: 140, // 수정 필요
              render: text => AlignCenterText({text})
            },
            */
            {
              //title: '주파수 대역(MHz)', dataIndex: 'frq_hz', key: ['frq_hz','service_code'], width: 130,
              title: "주파수 대역(MHz)",
              dataIndex: "frq_hz_100",
              key: "frq_hz_100",
              width: 130,
              /* render: text => AlignCenterText2({text}), */
              render: (text) => AlignCenterText({ text }),
              /*
              render: (frq_hz, service_code) =>
                frq_hz && service_code && frq_hz.toString().split(',').map((frq, service_code) => {
                  if ( service_code === '43') {
                    return AlignCenterText({
                      children:
                        Math.floor(frq / 1000000 / 1000) * 1000
                    })
                  }
                  else {
                    return AlignCenterText({
                      children:
                        Math.floor(frq / 1000000 / 100) * 100
                    })
                  }
*/
              /*
                  return AlignCenterText({
                    children:
                        Math.floor(frq / 1000000 / 100) * 100
                  })
*/

              //                }),
              /*
              render: frq_hz =>
                frq_hz && frq_hz.toString().split(',').map(frq => {
                  return AlignCenterText({
                    children:
                      <Tooltip title={frq} placement={"top"}>
                        {Math.floor(frq / 1000000 / 100) * 100}
                      </Tooltip>
                  })
                }),
               */

              // sorter: makeTableSorterFn("frq_hz"),
            },
            {
              title: "출력(W)",
              dataIndex: "arw_pwr_wtt",
              key: "arw_pwr_wtt",
              width: 100,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("arw_pwr_wtt"),
            },
            {
              title: "안테나설치형태",
              dataIndex: "arw_wek_nsn_form_cd_nm",
              key: "arw_wek_nsn_form_cd_nm",
              width: 160,
              // sorter: makeTableSorterFn("arw_wek_nsn_form_cd_nm"),
            },
            {
              title: "대표이득",
              dataIndex: "arw_gan_nmv",
              key: "arw_gan_nmv",
              width: 100,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("arw_gan_nmv"),
            },
            {
              title: "해발고",
              dataIndex: "arw_alt_altd_het",
              key: "arw_alt_altd_het",
              width: 100,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("arw_alt_altd_het"),
            },
            {
              title: "지상고",
              dataIndex: "arw_gnd_altd_het",
              key: "arw_gnd_altd_het",
              width: 100,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("arw_gnd_altd_het"),
            },
            {
              title: "노출고",
              dataIndex: "arw_exps_altd_het",
              key: "arw_exps_altd_het",
              width: 100,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("arw_exps_altd_het"),
            },
          ]}
          horizontalScroll={2200}
        />

        <WidgetVworldCityTypeForCenter />

        <WidgetLegend iconLegend={ICON_LEGEND} />
        <WidgetLegend
          iconLegend={ICON_LEGEND2}
          style={style2}
          legendStyle={legendStyle2}
        />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};

export default MapCellularSearch;
